import React from 'react'
import top from '../data/data-top'
import Rating from './Rating'

const TopSelling = () => {
  return (
    <div className='mt-20'>
      <h1 id='smartphones' className='text-2xl md:mt-auto font-semibold mb-8 text-gray-800'>
        SMARTPHONES
      </h1>
      <div className='flex flex-wrap gap-y-15 gap-x-8 justify-center xxl:justify-start'>
        {top.map(item => (
          <div
            key={item.id}
            className='cursor-pointer group max-w-full sm:max-w-xs bg-white hover:shadow-2xl transition duration-500 hover:scale-105 rounded-lg shadow-md dark:bg-gray-800 dark:border-gray-700'
          >
            <a>
              <img className='p-8 rounded-t-lg' src={item.image} alt='product image' />
            </a>
            <div className='px-5 pb-5'>
              <a>
                <h3 className='font-semibold tracking-tight text-gray-900 dark:text-white'>
                  {item.name}
                </h3>
              </a>
              <Rating value={item.stars} text={item.numberOfReviews} />
              <div className='flex justify-between items-center'>
                <span className='text-2xl font-bold text-gray-900 dark:text-white'>
                  ${item.price}
                </span>
                <a
                  href='#'
                  className='text-white group-hover:bg-red-500 duration-500 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800'
                >
                  Add to cart
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default TopSelling
